// imagenResponsiva.js — P3-9b (remate). UN solo lugar para armar las props
// responsivas de una <img> de foto de producto. El backend manda en /api/products:
//   image      → medium_large (768) con fallback a large/full,
//   imageSrcset → srcset "m.jpg 201w, l.jpg 686w, ml.jpg 768w" (medium/large/medium_large).
// Con `sizes` declarando el ANCHO de render, el navegador baja medium (~300) en 1x y
// medium_large (768) en 2x — fin de la miniatura 150×150 pixelada. Frontend-only → export ES.
//
// `sizes` acepta un NOMBRE de contexto conocido (ancho del hueco) o un valor CSS literal.
export const SIZES_FOTO = {
  tarjeta: '(max-width: 600px) 45vw, 200px', // tarjeta de catálogo/POS
  panel: '320px',    // inspector / panel de detalle
  tabla: '48px',     // celda de tabla
  miniatura: '64px', // thumb de lista/búsqueda/modal
};

// Dado un src + srcset (los que ya manda el backend) y un contexto de tamaño,
// devuelve las props de la <img>. Sin srcset NO se emite `sizes` (sería ruido) y la
// <img> cae a `src` tal cual. `loading`/`fetchpriority` según prioridad (primeras
// filas visibles → eager + high; el resto → lazy, para no pedir lo que no se ve).
export function propsFotoResponsiva({ src, srcset = '', sizes = 'miniatura', prioridad = false } = {}) {
  const tieneSrcset = !!(src && srcset);
  const sz = SIZES_FOTO[sizes] || sizes;
  const props = {
    src: src || undefined,
    srcSet: tieneSrcset ? srcset : undefined,
    sizes: tieneSrcset ? sz : undefined,
    loading: prioridad ? 'eager' : 'lazy',
  };
  if (prioridad) props.fetchpriority = 'high';
  return props;
}
